import { render, staticRenderFns } from "./MedicalForm.vue?vue&type=template&id=3b23d2fe&scoped=true"
import script from "./MedicalForm.vue?vue&type=script&lang=js"
export * from "./MedicalForm.vue?vue&type=script&lang=js"
import style0 from "./MedicalForm.vue?vue&type=style&index=0&id=3b23d2fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23d2fe",
  null
  
)

export default component.exports